import type {
  AnalysesSearchParams,
  AnalysesSearchResponse,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesSearch.types'
import getApiClient from 'src/utils/getApiClient'

const SEARCH_URL = '/api/search/analyses/'

const apiClient = getApiClient()

const apiAnalysesSearch = {
  async post(params: AnalysesSearchParams): Promise<AnalysesSearchResponse> {
    const { data } = await apiClient.post<AnalysesSearchResponse>(SEARCH_URL, params)

    return data
  },
}

export default apiAnalysesSearch
